import { GamePack } from '@/API';
import clsx from 'clsx';
import {
  elementsTransition,
  getSelectedGamePackIcon,
  getSelectedGamePackPalette
} from '@/utils/gamePacks';
import SelectedBackground from '../Host/Setup/SelectedBackground';
import { motion } from 'motion/react';

interface GamePackSelectionCardProps {
  gamePack: GamePack;
  selected: boolean;
  onClick: () => void;
}

export default function GamePackSelectionCard({
  gamePack,
  selected,
  onClick
}: GamePackSelectionCardProps) {
  const palette = getSelectedGamePackPalette(gamePack.palette);
  const icon = getSelectedGamePackIcon(gamePack.icon);

  return (
    <motion.button
      className={clsx(
        'flex items-center cursor-pointer bg-cover bg-bottom relative',
        selected
          ? 'border-black-dark bg-orange-100 w-247 rounded-xs pt-14 pb-18 px-12 elevated'
          : 'w-full px-8 py-12 '
      )}
      initial={{ rotate: 0 }}
      animate={selected ? { rotate: -2 } : { rotate: 0 }}
      onClick={onClick}
      transition={elementsTransition}
    >
      {selected && palette && <SelectedBackground palette={palette} />}
      {icon && (
        <motion.img
          src={icon.icons.small}
          alt={icon.label}
          className={clsx(selected ? 'w-40 h-40 mr-5' : 'w-25 h-25 mr-8', 'z-10')}
          key={String(selected)}
          initial={selected ? { scale: 0.5 } : { scale: 1 }}
          animate={{ scale: 1 }}
          transition={elementsTransition}
        />
      )}
      <div className="z-10">
        <p
          className={clsx(
            'text-left w-full',
            selected ? 'text-h3 text-white mb-2' : 'text-body-sm-strong text-left text-neutral-500'
          )}
        >
          <span className="mr-8">{gamePack.name}</span>

          {gamePack.isNew && (
            <span
              className={clsx(
                '-translate-y-2 uppercase text-[8px] leading-[10px] block px-4 pt-2 pb-2 border-[0.5px] border-white bg-accent-1-500 rounded-xl text-neutral-500 inline-block'
              )}
            >
              New
            </span>
          )}
        </p>
        <p className={clsx('text-xs text-white line-clamp-2 text-left', !selected && 'hidden')}>
          {gamePack.description}
        </p>
      </div>
    </motion.button>
  );
}
